import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Col, Row } from '@vds/grids';
import { TextLink, TextLinkCaret } from '@vds/buttons';
import { Line } from '@vds/lines';
import { ModalBody, ModalFooter, ModalTitle } from '@vds/modals';

import { VDSModal as Modal } from '../../../Modal/VDSModal';

import DueToday from './dueToday';
import DueMonthly from './dueMonthly';
import {
  getSession,
  viewport,
  getAPPID,
  getPageName,
  enableSelfSetup,
  isWHW,
  GetCurrentPageName,
  enablePegaProcessSteps,
  checkIsMidnight,
  getUrlName,
  isWHWP2,
} from '../../../Helpers';
import { postMessage } from '../../../Helpers/app';
import { apiUrls } from '../../../../../constants/apiUrl';
import '../../mobileCart.css';
import { Body } from '../../../Typography/index';

import globalStyleProps from '../../../../../assets/css/preprocess/global.scss';
import * as cartActions from '../../../../../services/Cart/actions';
import OneTimeChargesDiscounts from '../component/OneTimeChargesDiscounts';

import { isDisplayOneTimeCharges, isHideViewCart, isSaveCartDisplay, miniCartBackHandler } from '../../MiniCartUtils';

class MobileCart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      displayModal: false,
    };
  }

  componentDidMount() {
    if (viewport() === 'mfapp') {
      this.fabIconHidden();
    }
  }

  fabIconHidden = () => {
    const msg = {
      actionType: 'updateChatFab',
      chatFab: {
        hideFabOverlay: true,
      },
    };
    postMessage(msg);
  };

  showCartDetails = (callApi, e) => {
    if (callApi) {
      this.props.getCartDataFromApi();
    }

    if (e && e.keyCode === 9) {
      return;
    }
    const { displayModal } = this.state;
    this.setState({
      displayModal: !displayModal,
    });
    this.props.pageStatus(!this.props.isCartPageView);
  };

  handleOpenChange = (val) => {
    if (!val) {
      this.setState({
        displayModal: val,
      });
    }
  };

  showSaveCartDetails = () => {
    this.props.getShowCartStatus(true);
  };

  getPegaProcessPages = (currentPageName) => {
    if (currentPageName === 'plansOverview' || currentPageName === 'addons' || currentPageName === 'setup' || currentPageName === 'cart') {
      return true;
    }
    return false;
  };

  goBack = (e) => {
    e.preventDefault();
    const currentPageName = getUrlName(window.location.pathname);
    if (viewport() === 'mobile' || viewport() === 'mfapp' || viewport() === 'tablet') {
      if (
        enablePegaProcessSteps() &&
        this.props.allProcessStep?.length > 0 &&
        this.getPegaProcessPages(currentPageName) &&
        !getSession('ResumeCase')
      ) {
        const currentPage = GetCurrentPageName();
        const previousPage = this.props.allProcessStep[this.props.allProcessStep.indexOf(currentPage) - 1];
        if (previousPage) {
          if (previousPage === 'plansOverview.html') {
            window.location.href = apiUrls().redirectCBandPlans;
          } else if (previousPage === 'addons.html') {
            window.location.href = apiUrls().redirectAddons;
          } else if (previousPage === 'setup.html') {
            window.location.href = apiUrls().redirectSetup;
          }
        }
        if (
          this.props?.previousProcessStep === 'progressiveplan.html' ||
          (checkIsMidnight() && (currentPage === 'addons.html' || currentPageName === 'addons'))
        ) {
          this.props.history.push('progressiveplan.html');
        }
      } else {
        miniCartBackHandler(currentPageName, getAPPID(), this.props.history);
      }
    } else {
      this.props.history.goBack();
    }
  };

  calculatePrice = (item) => (
    <>
      {item && item.itemType === 'PLAN' && !item.isHomePhone && item.totalAmountWithDiscount && (
        <span className="fontSize_5 lineHeight20" style={{ color: '#000000' }}>
          {`$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}/mo`}
        </span>
      )}
    </>
  );

  isPreorder = () => getSession('isPreorder') === 'true';

  render() {
    const { isCartPageView, cartDetails, cartValueDetails } = this.props;
    const type = viewport();
    const appId = getAPPID();
    const securityDepositAmt = this.props.securityDepositAmt ? this.props.securityDepositAmt : {};
    const plansReferenceData = this.props.plansReferenceData ? this.props.plansReferenceData : '';
    const currentPageName = getUrlName(window.location.pathname);
    const hideViewCart = isHideViewCart(currentPageName);
    const isSaveCart = isSaveCartDisplay(currentPageName, appId) && !cartDetails?.saveCartSuccessData;
    const selectedSetupChoices = this.props?.cartValueDetails?.orderDetailsView?.installType;
    const isOneTimeCharges = isDisplayOneTimeCharges(currentPageName, selectedSetupChoices);

    const dueMonthlyList =
      this.props.cartDetails && this.props.cartDetails.cartDetailsJson ? this.props.cartDetails.cartDetailsJson.dueMonthlyList : [];

    document.getElementsByTagName('BODY')[0].style.overflow = this.state.displayModal ? 'hidden' : 'auto';

    let styleVal = {};
    if (type === 'mfapp') {
      styleVal = { margin: '0 !important' };
    }
    styleVal.maxHeight = globalStyleProps?.mycartNavbarHeight || '68px';
    const dueTodayVal =
      cartValueDetails && cartValueDetails.orderDetailsView
        ? cartValueDetails?.orderDetailsView?.dueTodayAmount
        : this.props?.cartValueDetails?.dueTodayAmount;
    const dueMonthlyVal =
      cartValueDetails && cartValueDetails.orderDetailsView
        ? cartValueDetails?.orderDetailsView?.dueMonthlyAmount
        : this.props?.cartValueDetails?.dueMonthlyAmount;
    const newApiCall = window.vzFlags?.miniCartApi;

    const dueMontTotalAAL = dueMonthlyVal;
    const totalDueMonthlyAAL = enableSelfSetup()
      ? dueMonthlyList?.map((item) => this.calculatePrice(item))
      : `$${dueMonthlyVal ? parseFloat(dueMonthlyVal || 0.0).toFixed(2) : ''}/mo`;

    let dueMonthlyAmountDisplay;

    if (appId === 'AAL') {
      if (isWHW() || isWHWP2()) {
        dueMonthlyAmountDisplay = `$${dueMonthlyVal ? parseFloat(dueMonthlyVal || 0.0).toFixed(2) : ''}/mo`;
      } else if (dueMonthlyList?.length) {
        if (checkIsMidnight()) {
          dueMonthlyAmountDisplay = `$${dueMontTotalAAL ? parseFloat(dueMontTotalAAL || 0.0).toFixed(2) : ''}/mo`;
        } else {
          dueMonthlyAmountDisplay = totalDueMonthlyAAL;
        }
      } else if (newApiCall) {
        dueMonthlyAmountDisplay = `$${dueMonthlyVal ? parseFloat(dueMonthlyVal || 0.0).toFixed(2) : ''}/mo`;
      }
    } else {
      dueMonthlyAmountDisplay = `$${dueMonthlyVal ? parseFloat(dueMonthlyVal || 0.0).toFixed(2) : ''}/mo`;
    }
    if (!cartValueDetails) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="fullWidth" style={styleVal}>
          <div className="border_CC onlyBottomBorder height72">
            <Row className="justify-space-between ">
              <Col colSizes={{ mobile: 2, tablet: 3, desktop: 1 }} style={{ padding: '22px 0px 12px 30px' }} className="alignItemsCenter">
                {!((isWHW() && getPageName() === 'displayShippingOptions') || (isWHWP2() && getPageName() === 'getStreamingDevices')) && (
                  <TextLinkCaret surface="light" disabled={false} iconPosition="left" ariaLabel="back" onClick={(e) => this.goBack(e)} />
                )}
              </Col>
              <Col colSizes={{ mobile: 2, tablet: 6, desktop: 1 }} className="pad12 onlyTopPad onlyTopMargin textAlignLeft">
                <div style={{ padding: '0 0 4px' }}>
                  <Body size="small" color="#6F7171">
                    {this.isPreorder() ? 'Due at shipment' : 'Due today'}
                  </Body>
                </div>

                <div id="dueTodayAmount">
                  <Body size="large"> {`$${dueTodayVal ? parseFloat(dueTodayVal || 0.0).toFixed(2) : ''}`}</Body>
                </div>
              </Col>
              <Col colSizes={{ mobile: 2, tablet: 4, desktop: 1 }} className="pad12 onlyTopPad onlyTopMargin textAlignLeft">
                <div style={{ padding: '0 0 4px' }}>
                  <Body size="small" color="#6F7171">
                    Due monthly
                  </Body>
                </div>
                <div id="dueMonthlyAmount">
                  <Body size="large">{dueMonthlyAmountDisplay}</Body>
                </div>
              </Col>
              <Col colSizes={{ mobile: 2, tablet: 4, desktop: 1 }} className="widthAutoImp">
                <Col
                  colSizes={{ mobile: 2, tablet: 6, desktop: 1 }}
                  className="textCenter pad12 onlyTopPad fontSize_2"
                  style={{ marginRight: '10px' }}
                >
                  {!hideViewCart && (
                    <TextLink
                      ariaLabel="View Cart Button"
                      onClick={() => this.showCartDetails('callApi')}
                      onKeyDown={() => this.showCartDetails('callApi')}
                      tabIndex="0"
                      type="standAlone"
                      id="ViewCart"
                    >
                      View Cart
                    </TextLink>
                  )}
                  {isSaveCart && (
                    <TextLink
                      ariaLabel="Save Cart"
                      onClick={() => this.showSaveCartDetails()}
                      onKeyDown={() => this.showSaveCartDetails()}
                      tabIndex="0"
                      type="inline"
                      size="small"
                      name="Save cart"
                      id="SaveCart"
                    >
                      Save cart
                    </TextLink>
                  )}
                </Col>
              </Col>
            </Row>
          </div>
        </div>

        {this.state.displayModal && (
          <Modal ariaLabel="Order Summary" opened={this.state.displayModal} onOpenedChange={this.handleOpenChange}>
            <ModalTitle>Order Summary</ModalTitle>
            <ModalBody>
              <section>
                <DueToday cartDetails={cartValueDetails} plansReferenceData={plansReferenceData} securityDepositAmt={securityDepositAmt} />
                <Line type="secondary" surface="light" />
                <DueMonthly
                  taxFeeText={this.props.taxFeeText}
                  cartDetails={cartValueDetails}
                  plansReferenceData={plansReferenceData}
                  isCartPageView={isCartPageView}
                  disneyPromoHelperText={this.props.disneyPromoHelperText}
                />
                <OneTimeChargesDiscounts plansReferenceData={plansReferenceData} isOneTimeCharges={isOneTimeCharges} appId={appId} />
              </section>
            </ModalBody>

            <ModalFooter
              buttonData={{
                primary: {
                  width: '100%',
                  children: 'Close',
                  onClick: () => {
                    this.handleOpenChange(false);
                  },
                },
              }}
            />
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

MobileCart.propTypes = {
  pageStatus: PropTypes.func,
  cartDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
  isCartPageView: PropTypes.bool,
  history: PropTypes.object,
  securityDepositAmt: PropTypes.any,
  getShowCartStatus: PropTypes.func,
  getCartDataFromApi: PropTypes.func,
  cartValueDetails: PropTypes.object,
  allProcessStep: PropTypes.any,
  taxFeeText: PropTypes.string,
  previousProcessStep: PropTypes.string,
  disneyPromoHelperText: PropTypes.string,
};

const mapStateToProps = (state) => ({
  progressSteps: state.progressSteps,
  cartDetails: state.cartDetails,
  allProcessStep: state.Redirection?.allProcessStep,
  selectedPlan: state.cBandPlans?.planSelected || {},
  cBandPlans: state.cBandPlans?.plans?.output?.plans || {},
  progressivePlanDetails: state?.progressivePlans || {},
  previousProcessStep: state.Redirection?.previousProcessStep,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MobileCart));
